import { Button } from 'antd';
import styled from 'styled-components';

export const DefaultButton = styled(Button as any)`
  &.ant-btn {
    background-color: white;
  }
`;
